import { ArtistResponse, Artist } from './types'; // eslint-disable-line

export function formatArtist(artist: ArtistResponse): Artist {
  return {
    id: artist.uri.split(':')[2],
    ...artist,
  };
}
